import { type FilterValues } from "components/filters/FilterContext";
import { DefaultProductionSortFilter, getSortOption } from "components/filters/Filters/FilterTypes/ProductionSortFilterType";
import { mapArtistFilterToInstruction, mapKeywordFilterToInstruction, mapPeriodFilterToInstruction, mapResponseToArtistFilter, mapResponseToKeywordFilter, mapResponseToPeriodFilter, mapResponseToStatusFilter, mapStatusFilterToInstruction } from "components/filters/mappingUtils";

export const mapFilterValuesToInstruction = (
  filterSet: server.dto.FilterSets,
  filter: FilterValues,
  page: number,
  perPage: number
): server.dto.PaginatedProductionInstruction => {
  return {
    keyword: mapKeywordFilterToInstruction(filter.keyword),
    artistIds: mapArtistFilterToInstruction(filter.artist),
    statuses: mapStatusFilterToInstruction(filter.statuses),
    period: mapPeriodFilterToInstruction(filter.period),
    order: filter.productionSort.sortOption.value,
    page,
    perPage,
    cache: filterSet
  };
};

export const mapResponseToFilterValues = (
  response: server.dto.ListProductionFilters,
  values: FilterValues
): Partial<FilterValues> => ({
  keyword: mapResponseToKeywordFilter(response.keyword),
  artist: mapResponseToArtistFilter(response.artists),
  statuses: mapResponseToStatusFilter(response.statuses, values.statuses),
  period: mapResponseToPeriodFilter(response.period),
  productionSort: {
    sortOption: (response.order !== "date_asc")
      ? getSortOption(response.order)
      : getSortOption(DefaultProductionSortFilter)
  }
});